import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useFaireProgramsRetailerNodes } from "./nodesV2/useFaireProgramsRetailerNodes";
import { useHowFaireWorksRetailerNodes } from "./nodesV2/useHowFaireWorksRetailerNodes";
import { useInsiderRetailerNodes } from "./nodesV2/useInsiderRetailerNodes";
import { useInvoicesRetailerNodes } from "./nodesV2/useInvoicesRetailerNodes";
import { useOrdersRetailerNodes } from "./nodesV2/useOrdersRetailerNodes";
import { usePaymentsRetailerNodes } from "./nodesV2/usePaymentsRetailerNodes";
import { useSettingsRetailerNodes } from "./nodesV2/useSettingsRetailerNodes";
import { useVerifyAccountRetailerNodes } from "./nodesV2/useVerifyAccountRetailerNodes";
export var useRetailerNodesV2 = function useRetailerNodesV2() {
  var verifyAccountRetailerNodes = useVerifyAccountRetailerNodes();
  var ordersRetailerNodes = useOrdersRetailerNodes();
  var settingsRetailerNodes = useSettingsRetailerNodes();
  var paymentsRetailerNodes = usePaymentsRetailerNodes();
  var invoicesRetailerNodes = useInvoicesRetailerNodes();
  var insiderRetailerNodes = useInsiderRetailerNodes();
  var faireProgramsRetailerNodes = useFaireProgramsRetailerNodes();
  var howFaireWorksRetailerNodes = useHowFaireWorksRetailerNodes();
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    Root: {
      id: "Root",
      children: ["VerifyAccount", "Orders", "SettingsAndAccount", "Payments", "Invoices", "Insider", "FairePrograms", "HowFaireWorks"],
      level: 0
    }
  }, verifyAccountRetailerNodes), ordersRetailerNodes), settingsRetailerNodes), paymentsRetailerNodes), invoicesRetailerNodes), insiderRetailerNodes), faireProgramsRetailerNodes), howFaireWorksRetailerNodes);
};